import script from "./TemplateGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateGallery.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateGallery.vue?vue&type=style&index=0&id=1fc521bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_354139e77772094841bf527df78bd682/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc521bf"]])

export default __exports__